<template>
  <div class="popupModal" :class="{active: settings.show}">
    <previewImagePopup :settings="previewImagePopupSettings"></previewImagePopup>
    <div class="popupModal__wrapper">
      <div class="popupModal__content" id="popupModal__content">
        <div class="close-icon__wrapper">
          <span class="close-icon" @click="settings.show = null">
            <img src="@/assets/icons/ic_close_white.svg">
          </span>
        </div>
        <div class="service_info">
            <div class="no_data_wrapper" v-if="settings.serviceInfoRatesPopup && settings.serviceInfoRatesPopup.length == 0">
                <span>{{translate('noServiceLogs')}}</span>
            </div>
            <div class="service_logs_title_wrapper" v-if="settings.customerName">
                <span>{{settings.customerName}}</span>
            </div>
            <div class="frequency_service_wrapper" v-if="settings.cleaningSchedule">
                <span>Frequency of service requested:<br>{{ settings.cleaningSchedule }} <span>time(s)</span> per week</span>
            </div>
            <div class="service_logs_title_wrapper" v-if="settings.serviceInfoRatesPopup && settings.serviceInfoRatesPopup.length > 0">
                <span>Last <span v-if="settings.serviceInfoRatesPopup.length >= 10">10</span> services:</span>
            </div>
          <div class="service_info_content__wrapper" v-for="(rate, index) in settings.serviceInfoRatesPopup"
               :key="index">
            <div class="content_titles">
                <div class="content_titles__wrapper">
                  <div class="local_date">
                    {{ rate.local_date }}
                  </div>
                </div>
                <div class="content_titles__wrapper">
                  <div class="serviceLog"  v-if="rate.sec_level.length > 0">
                    <div v-for="(item, index) in rate.sec_level" :key="index">{{ item }}</div>
                  </div>
                </div>
                <div class="content_titles__wrapper" v-if="rate.additional_data">
                    <div class="additional_data">{{ rate.additional_data }}</div>
                </div>
                <div class="content_titles__wrapper" v-if="rate.author">
                    <div class="author_name">By {{ rate.author }}</div>
                </div>
                <div class="content_titles__wrapper">
                  <div class="photo" v-if="rate.attachments.images.length !== 0">
                    <div class="preview">
                      <img v-for="(image, index) in rate.attachments.images"
                           :key="index"
                           :src="image.previewUrl"
                           @click="onVoteImageClick(image)"
                      />
                    </div>
                  </div>
                </div>
                <div class="content_titles__wrapper">
                  <div class="audio">
                    <audio controls='controls' v-if="rate.attachments.audio !== null">
                      <source :src="audioLink">
                    </audio>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="photo-modal__buttons">

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import errorMixin from "@/mixins/errorMixin";
import previewImagePopup from "@/components/widgets/previewImagePopup";

export default {
  name: "PopupModal",
  mixins: [mixin, errorMixin],
  components: {
    previewImagePopup
  },
  data() {
    return {
      showInfoModal: this.settings !== null,
      previewImagePopupSettings: null,
    }
  },
  watch: {
    settings(newValue) {
      this.showInfoModal = newValue !== null
    }
  },
  props: {
    settings: {
      type: [Object, null],
      default: () => {
        return {}
      }
    },
  },
  methods: {
    onVoteImageClick(image) {
      this.previewImagePopupSettings = {
        image: image.originUrl
      }
    },
  }
}
</script>

<style scoped>

.no_data_wrapper {
    text-align: center;
    margin-top: 48px;
    font-size: 18px;
}

.frequency_service_wrapper {
    text-align: start;
    font-size: 16px;
    margin-bottom: 16px;
    color: #404040;
}
.service_logs_title_wrapper {
    text-align: center;
    font-size: 18px;
    margin-bottom: 8px;
}

.service_info_title__wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.service_info_content__wrapper {
  display: flex;
  border-bottom: solid 1px rgb(0,0,0, .3);
  padding-top: 10px;
  padding-bottom: 10px;
}

.service_info {
  height: 500px;
  overflow: auto;
}

.date_content, .info_content {
  padding-bottom: 10px;
  padding-top: 10px;
}

.date_title, .info_title {
  font-size: 20px;
}

.content_titles__wrapper {
  display: flex;
}
.content_titles__data, .content_titles__services, .content_titles__photo, .content_titles__audio {
  width: 80px;
}

.content_titles {
  display: flex;
  flex-direction: column;
}

.serviceLog {
  display: flex;
  flex-direction: column;
}
.additional_data {
    font-weight: 600 !important;
    white-space: pre-wrap;
    line-height: 19px;
    margin-top: 4px;
}

.author_name {
    font-weight: 600 !important;
    white-space: pre-wrap;
    line-height: 19px;
    margin-top: 4px;
}

.serviceLog div {
  margin-right: 10px;
}

.preview {
  cursor: pointer;
}

.photo {
  display: flex;
  align-items: center;
}
.content_titles__photo {
  max-width: 100%;
  max-height: 60px;
  padding-right: 5px;
  height: 60px;
}
.content_titles__services {
  height: 40px;
}


</style>